<template>
  <v-card
    class="dash-card rounded-lg"
    elevation="0"
    color="white"
    style="
      min-height: 120;
      height: 98%;
      width: 100%;
      font-family: 'Archivo', sans-serif;
    "
    :class="{ 'mb-n5': !mdAndUp }"
    v-if="mdAndUp"
  >
    <v-btn
      icon
      x-small
      class="refresh-button"
      @click="refreshDashCard"
      v-if="mdAndUp && refreshInfo !== ''"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <v-card-title
      style="font-family: 'Archivo', sans-serif !important"
      class="d-flex justify-center pt-2 pb-3 fontDash-title mb-n2 text-body-1"
      :class="{ 'text-subtitle-4 mb-n10': !mdAndUp }"
    >
      {{ title }}
      <v-tooltip
        top
        height
        class="tooltip-render"
        max-width="600"
        max-height="40"
        size="15"
        color="transparent"
        v-if="title === 'Faturamento Total'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-0 pt-0 btn-icon"
            icon
            x-small
            v-bind="attrs"
            v-on="on"
          >
            <InfoIcon class="mt-0 pt-0" />
          </v-btn>
        </template>
        <v-card color="tooltip-card black">
          <v-card-text class="text-white">
            Valor líquido descontado das taxas
          </v-card-text>
        </v-card>
      </v-tooltip>
    </v-card-title>
    <v-card-text
      class="d-flex justify-center align-center mb-1"
      style="font-family: 'Archivo', sans-serif !important"
    >
      <v-progress-circular
        :size="60"
        :color="$config.dados.corinputs"
        v-if="loading"
        indeterminate
        class="mt-n2"
      ></v-progress-circular>
      <v-row justify="start" v-else>
        <template v-if="mdAndUp">
          <template v-if="information">
            <v-col cols="12" sm="8" class="d-flex flex-column align-center">
              <span
                v-for="(infoTitle, index) in information.titles"
                :key="index"
                style="font-family: 'Archivo', sans-serif !important"
                class="text-body-1"
              >
                {{ infoTitle }}
              </span>
            </v-col>
            <v-col cols="12" sm="1" class="d-flex flex-column align-start">
              <span
                style="font-family: 'Archivo', sans-serif !important"
                v-for="(infoValues, index) in information.values"
                :key="index"
                class="text-body-3"
              >
                {{ infoValues }}
              </span>
            </v-col>
          </template>
          <v-row justify="center">
            <template v-if="percent && mdAndUp">
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="d-flex flex-column align-center"
              >
                <h1
                  v-if="percent.value"
                  :class="percent.class"
                  class="mb-2 text-h6 mt-4"
                  style="font-family: 'Archivo', sans-serif !important"
                >
                  {{ percent.value }}
                </h1>
              </v-col>
            </template>
            <template v-if="percent && !mdAndUp">
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="d-flex flex-column align-center"
              >
                <h1
                  v-if="percent.value"
                  :class="percent.class"
                  class="mb-6 text-h2"
                  style="font-family: 'Archivo', sans-serif !important"
                >
                  {{ percent.value }}
                </h1>
              </v-col>
            </template>
            <template v-if="info">
              <h1
                :class="percent.class"
                class="mb-6 text-h2"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ info }}
              </h1>
            </template>
          </v-row>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
import InfoIcon from "@/components/icons/InfoIcon.vue";
export default {
  name: "DashCard",
  mixins: [displayHelpers],
  components: {
    InfoIcon,
  },
  props: {
    refreshInfo: {
      type: String,
      required: false,
      default: "",
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    information: {
      type: Object,
      required: false,
      default: () => {},
    },
    percent: {
      required: false,
    },
    percentMobile: {
      type: Object,
      required: false,
      default: () => {},
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    table: {
      type: Boolean,
      required: false,
      default: false,
    },
    headers: {
      type: Array,
      required: false,
      default: () => [],
    },
    list: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    info: {
      type: String,
      required: false,
      default: () => "",
    },
    click: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  computed: {
    applyFillHeight() {
      return this.fillHeight ? "height: 100%" : "";
    },
    hasPercentContent() {
      return Object.keys(this.percent) >= 0;
    },
    isNegative() {
      return (
        this.percent.value.includes("-") || parseFloat(this.percent.value) < 0
      );
    },
  },
  methods: {
    refreshDashCard() {
      this.$dashboard.refreshDashInfo(this.refreshInfo);
    },
  },
};
</script>

<style scoped>
.dash-card2 {
  border-radius: 20px;
  margin: 0.5rem;
  background: #e9e8ed;
  box-shadow: 20px 20px 60px #c6c5c9, -20px -20px 60px #ffffff;
  position: relative;
}
.dash-card {
  border-radius: 15px;
  /* background: #e6e6e6 !important;
  box-shadow: 5px 5px 100px #bdbdbd, -5px -5px 100px #ffffff !important; */
  /* background: #e6e6e6 !important;
  box-shadow: 5px 5px 0px #5c5c5c, -5px -5px 0px #ffffff !important; */
  /* border-radius: 15px;
  position: relative;
  background: white !important; */
  /* box-shadow: inset -26px 26px 52px #c3c2c2, inset 26px -26px 52px #e1e0e0 !important; */
}
.positive-percent {
  color: #572c88;
  font-size: 0.875rem;
}

.negative-percent {
  color: #d70200;
  font-size: 0.875rem;
}
.refresh-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.text-white {
  color: white !important;
  text-align: center;
}

.btn-icon {
  font-size: 16px !important;
  padding-top: -5px !important;
  height: 20px !important;
}

.tooltip-card {
  position: relative;
}
.tooltip-card:after {
  content: "";
  width: 15px;
  height: 15px;
  position: absolute;
  bottom: -0.8rem;
  right: 50%;
  transform: rotate(180deg) translateX(-50%);
  background-color: rgb(0, 0, 0);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
/* .checkin-percent {
  padding: 0px 10px !important;
} */
</style>
